export const iconFontAwesomeUsersPeopleUserLargeSlash = (
	<i className="fa-solid fa-user-large-slash"></i>
);
